import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import BulkActionModel, {
  type BulkActionCustomDeleteCustomProperty,
  type BulkActionResponseIncludesUpdatedFundProperties,
} from 'donor-elf-web/models/bulk-action';
import { type PropertiesPropertyRouteModel } from 'donor-elf-web/routes/funds/fund/properties/property';
import ContactsCache, {
  isGroupsContactCustomPropertyInfo,
} from 'donor-elf-web/services/contacts-cache';
import Settings from 'donor-elf-web/services/settings';

export default class PropertiesPropertyDeleteController extends Controller {
  @service declare contactsCache: ContactsCache;
  @service declare settings: Settings;

  model!: PropertiesPropertyRouteModel;

  bulkAction?: BulkActionModel;
  @tracked bulkActionComplete = false;
  @tracked deleting = false;
  @tracked deleteError = false;

  get isGroupsProperty() {
    return isGroupsContactCustomPropertyInfo(this.model.property);
  }

  get isReadonlyProperty() {
    return this.model.property.r === true;
  }

  @action
  templateWillDestroy() {
    this.bulkAction = undefined;
    this.bulkActionComplete = false;
    this.deleting = false;
    this.deleteError = false;
  }

  @action
  async delete() {
    this.bulkActionComplete = false;
    this.deleting = true;
    this.bulkAction = this.store.createRecord('bulk-action');
    this.bulkAction.actionType = 'delete_custom_property';
    (this.bulkAction.custom as BulkActionCustomDeleteCustomProperty) = {
      property_label: this.model.property.l,
    };
    try {
      await this.bulkAction.save();
    } catch (error: any) {
      this.deleteError = true;
    }
  }

  @action
  async handleBulkActionStatusChange(bulkAction: BulkActionModel) {
    if (bulkAction.status === 'completed') {
      let response =
        bulkAction.response as BulkActionResponseIncludesUpdatedFundProperties;
      await bulkAction.destroyRecord();
      if (response.contact_ids.length < 250) {
        await this.contactsCache.reloadSpecificContacts(response.contact_ids);
      } else {
        await this.contactsCache.loadContacts({ forceLoad: true });
      }
      this.settings.fundSettings!.contactCustomInfo!.properties =
        response.updated_fund_properties;
      // break the custom properties cache
      this.contactsCache.customPropertiesCacheIndex += 1;
      this.bulkActionComplete = true;
    } else if (bulkAction.status === 'error') {
      this.deleteError = true;
      this.bulkActionComplete = true;
    }
  }
}
